import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSiteSettings } from '../../../siteSettings';

const AdminSidebar = ({ collapsed, onToggle, onNavigate }) => {
  const settings = useSiteSettings();

  return <aside className={`admin-sidebar ${collapsed ? 'is-collapsed' : ''}`}>
    <div className="admin-sidebar-brand">
      <div className="admin-sidebar-couple-name">{settings.coupleNames}</div>
    </div>
    <nav className="admin-sidebar-nav" aria-label="Navigation administrateur">
      <NavLink exact to="/admin/dashboard" activeClassName="is-active" title="Tableau de bord" onClick={onNavigate}>
        <i className="fa fa-dashboard" aria-hidden="true" /><span>Tableau de bord</span>
      </NavLink>
      <NavLink to="/admin/couple" activeClassName="is-active" title="Les mariés" onClick={onNavigate}>
        <i className="fa fa-heart" aria-hidden="true" /><span>Les mariés</span>
      </NavLink>
      <NavLink to="/admin/story" activeClassName="is-active" title="Notre histoire" onClick={onNavigate}>
        <i className="fa fa-book" aria-hidden="true" /><span>Notre histoire</span>
      </NavLink>
      <NavLink to="/admin/events" activeClassName="is-active" title="Quand et où" onClick={onNavigate}>
        <i className="fa fa-calendar" aria-hidden="true" /><span>Quand et où</span>
      </NavLink>
      <NavLink to="/admin/gallery" activeClassName="is-active" title="Galerie" onClick={onNavigate}>
        <i className="fa fa-picture-o" aria-hidden="true" /><span>Galerie</span>
      </NavLink>
      <NavLink to="/admin/messages" activeClassName="is-active" title="Messages RSVP" onClick={onNavigate}>
        <i className="fa fa-envelope" aria-hidden="true" /><span>Messages RSVP</span>
      </NavLink>
      <NavLink to="/admin/users" activeClassName="is-active" title="Utilisateurs" onClick={onNavigate}>
        <i className="fa fa-users" aria-hidden="true" /><span>Utilisateurs</span>
      </NavLink>
      <NavLink to="/admin/site-settings" activeClassName="is-active" title="Gestion du site" onClick={onNavigate}>
        <i className="fa fa-cog" aria-hidden="true" /><span>Gestion du site</span>
      </NavLink>
    </nav>
    <button type="button" className="admin-sidebar-toggle" onClick={onToggle} title="Réduire le menu">
      <i className={`fa fa-chevron-${collapsed ? 'right' : 'left'}`} aria-hidden="true" />
      {!collapsed && <span>Réduire le menu</span>}
    </button>
  </aside>;
};

export default AdminSidebar;
